<template>
    <div>
        <company-form ref="companyForm" @save-success="saveSuccess">
        </company-form>

        <company-children-list-panel :search="companyListSearch" v-if="form.model.id != null">

        </company-children-list-panel>

        <department-children-list-panel :search="departmentListSearch" v-if="form.model.id != null">

        </department-children-list-panel>

        <project-children-list-panel :search="projectListSearch" v-if="form.model.id != null">

        </project-children-list-panel>

        <position-relation-panel :options="positionOptions" v-if="form.model.id !=null">

        </position-relation-panel>

        <role-relation-panel :options="options" v-if="form.model.id != null">

        </role-relation-panel>

        <person-table-panel :search="personListSearch" v-if="form.model.id != null">

        </person-table-panel>

    </div>
</template>

<script>
    import CompanyForm from '@/views/organization/company/company.form'
    import CompanyChildrenListPanel from "@/views/organization/company/company.children.list.panel";
    import DepartmentChildrenListPanel from "@/views/organization/department/department.children.list.panel";
    import ProjectChildrenListPanel from "@/views/organization/project/project.children.list.panel";
    import PersonTablePanel from "@/views/organization/person/person.table.panel";
    import PositionRelationPanel from '@/views/organization/position/position.relation.panel';

    import RoleRelationPanel from '@/views/organization/role/role.relation.panel'
    import OrganizationServer from '@/api/organization'
    import {PAGE_STATUS_DETAIL_ADD, PAGE_STATUS_DETAIL_EDIT, PAGE_STATUS_DETAIL_SHOW} from './company.common'
    import {createNamespacedHelpers} from "vuex"


    const CurrentRestResource = OrganizationServer.company;

    const companyList = createNamespacedHelpers("organization/company/list");
    const companyForm = createNamespacedHelpers("organization/company/form");
    // const companyDetail = createNamespacedHelpers("organization/company/detail");

    import eventBus from "@/util/common/event-bus";

    export default {
        name: "CompanyDetail",
        components: {
            CompanyForm,
            CompanyChildrenListPanel,
            DepartmentChildrenListPanel,
            ProjectChildrenListPanel,
            PersonTablePanel,
            RoleRelationPanel,
            PositionRelationPanel,
        },
        data() {
            return {
                options: {
                    addable: true,
                    relationIdKey: 'orgId',
                    relationId: null,
                    table: {
                        api: OrganizationServer.orgRole,
                        search: {
                            eq_roleStatus: true,
                        },
                        columns: [{
                            name: 'roleCode',
                            title: '角色编码',
                            linkDetail: true,
                            format(row) {
                                return row.role.code;
                            },
                            search: {
                                name: 'like_roleCode',
                                type: 'input',
                            },
                        }, {
                            name: 'roleName',
                            title: '角色名称',
                            format(row) {
                                return row.role.name;
                            },
                            search: {
                                name: 'like_roleName',
                                type: 'input',
                            },
                        }, {
                            name: 'roleDescription',
                            title: '角色描述',
                            format(row) {
                                return row.role.description;
                            },
                            search: {
                                name: 'like_roleDescription',
                                type: 'input',
                            },
                        }, {
                            name: 'roleStatus',
                            title: '角色状态',
                            format(row) {
                                let status = row.role.status;
                                let options = this.search.options;
                                let text = '';
                                for (let i = 0, len = options.items.length; i < len; i++) {
                                    if (String(options.items[i][options.valueKey]) === String(status)) {
                                        text = options.items[i][options.textKey];
                                        break;
                                    }
                                }
                                return text;
                            },
                            search: {
                                name: 'eq_roleStatus',
                                type: 'select',
                                options: {
                                    items: [{
                                        value: true,
                                        text: '启用',
                                    }, {
                                        value: false,
                                        text: '停用',
                                    }],
                                    valueKey: 'value',
                                    textKey: 'text',
                                },
                            },
                        }],
                    },
                },
                positionOptions: {
                    addable: true,
                    relationIdKey: 'orgId',
                    relationId: null,
                    table: {
                        api: OrganizationServer.orgPosition,
                        search: {},
                        columns: [
                            {
                                name: 'orgName',
                                title: '组织名称',
                                search: {
                                    name: 'like_orgName',
                                    type: 'input',
                                },
                                format(row) {
                                    return row.orgTree.name;
                                },
                            },
                            {
                                name: 'positionName',
                                title: '岗位名称',
                                search: {
                                    name: 'like_positionName',
                                    type: 'input',
                                },
                                format(row) {
                                    return row.position.name;
                                },
                            },
                            {
                                name: 'description',
                                title: '岗位描述',
                                search: null,
                                format(row) {
                                    return row.position.description;
                                },
                            }
                        ],
                    },
                },
            };
        },
        computed: {
            ...companyList.mapGetters(['pageSearch']),
            ...companyForm.mapState(['form']),
            // ...companyDetail.mapState(['fnCallFlag']),
            companyListSearch() {
                return {
                    parentOrgId: this.form.model.orgId,
                };
            },
            departmentListSearch() {
                return {
                    parentOrgId: this.form.model.orgId,
                };
            },
            projectListSearch() {
                return {
                    parentOrgId: this.form.model.orgId,
                };
            },
            personListSearch() {
                return {
                    parentOrgId: this.form.model.orgId,
                    auto: true,
                    isNotNull_personId: true,
                };
            },
        },
        watch: {
            'form.model.orgId': {
                immediate: true,
                handler() {
                    this.options.relationId = this.form.model.orgId;
                    this.options.table.search.eq_orgId = this.form.model.orgId;

                    this.positionOptions.relationId = this.form.model.orgId;
                    this.positionOptions.table.search.parentOrgId = this.form.model.orgId;
                }
            },
            '$route': {
                deep: true,
                immediate: true,
                handler() {
                    let operation = this.$route.query.operation, id = this.$route.query.id;
                    operation = operation == null ? PAGE_STATUS_DETAIL_ADD : operation;
                    if (id == null || PAGE_STATUS_DETAIL_ADD.endsWith(operation)) {
                        this.toAdd();
                    } else if (PAGE_STATUS_DETAIL_SHOW.endsWith(operation)) {
                        this['setCurrentRowId'](id);
                        this.toShow(id);
                    } else if (PAGE_STATUS_DETAIL_EDIT.endsWith(operation)) {
                        this['setCurrentRowId'](id);
                        this.toEdit(id);
                    }
                },
            },
            /*'fnCallFlag': {
                deep: true,
                immediate: true,
                handler(fnCallFlag) {
                    if (fnCallFlag != null) {
                        if (fnCallFlag.saveAdd != null && fnCallFlag.saveAdd === true) {
                            this.saveAdd();
                        }
                        if (fnCallFlag.saveEdit != null && fnCallFlag.saveEdit === true) {
                            this.saveEdit();
                        }
                        if (fnCallFlag.invalidate != null && fnCallFlag.invalidate === true) {
                            this.invalidate();
                        }
                        if (fnCallFlag.revalidate != null && fnCallFlag.revalidate === true) {
                            this.revalidate();
                        }
                        if (fnCallFlag.remove != null && fnCallFlag.remove === true) {
                            this.remove();
                        }
                    }
                },
            },*/
        },
        methods: {
            ...companyList.mapMutations(['setCurrentRowId', 'removeVisitedId']),
            ...companyList.mapActions(['doQueryByPage']),
            // ...companyDetail.mapMutations(['setFnCallFlag']),
            async saveSuccess(data) {
                this.callListQuery();
                await this.$router.push({
                    path: '/organization/company/detail',
                    query: {operation: 'show', id: data.id}
                });
            },
            async toAdd(data, options) {
                await this.$nextTick();
                this.$refs.companyForm.toAdd(data, options);
            },
            async toShow(id) {
                await this.$nextTick();
                await this.$refs.companyForm.toShow(id);
            },
            async toEdit(id, options) {
                await this.$nextTick();
                return this.$refs.companyForm.toEdit(id, options);
            },
            async saveAdd() {
                try {
                    return this.$refs.companyForm.saveAdd();
                } finally {
                    // this['setFnCallFlag'](null);
                }
            },
            async saveEdit() {
                try {
                    return this.$refs.companyForm.saveEdit();
                } finally {
                    // this['setFnCallFlag'](null);
                }
            },
            async invalidate() {
                try {
                    let confirmed = await this.$confirm('确定停用吗？', '作废提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                    if (confirmed) {
                        let res = await CurrentRestResource.invalidate(this.form.model.id);
                        if (res.data.code === "200") {
                            // this['removeVisitedId'](this.form.model.id);
                            this.toShow(this.form.model.id);
                            this.$message.success('停用成功！');
                            this.callListQuery();
                            // await this.$router.push({path: '/organization/company/list'});
                        } else {
                            this.$message.error(`停用失败：${res.data.message}`);
                        }
                    }
                } finally {
                    // this['setFnCallFlag'](null);
                }
            },
            async revalidate() {
                try {
                    let confirmed = await this.$confirm('确定启用吗？', '启用提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                    if (confirmed) {
                        let res = await CurrentRestResource.revalidate(this.form.model.id);
                        if (res.data.code === "200") {
                            // this['removeVisitedId'](this.form.model.id);
                            this.toShow(this.form.model.id);
                            this.$message.success('启用成功！');
                            this.callListQuery();
                            // await this.$router.push({path: '/organization/company/list'});
                        } else {
                            this.$message.error(`启用失败：${res.data.message}`);
                        }
                    }
                } finally {
                    // this['setFnCallFlag'](null);
                }
            },
            async remove() {
                try {
                    let confirmed = await this.$confirm('确定删除吗？', '删除提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                    if (confirmed) {
                        let res = await CurrentRestResource.delete(this.form.model.id);
                        if (res.data.code === "200") {
                            this['removeVisitedId'](this.form.model.id);
                            this.$message.success('删除成功！');
                            this.callListQuery();
                            await this.$router.push({path: '/organization/company/list'});
                        } else {
                            this.$message.error(`删除失败：${res.data.message}`);
                        }
                    }
                } finally {
                    // this['setFnCallFlag'](null);
                }
            },
            callListQuery() {
                this['doQueryByPage'](JSON.parse(JSON.stringify(this['pageSearch'])));
            },
        },
        created() {
            eventBus.bind('company_saveAdd', {next: this.saveAdd});
            eventBus.bind('company_saveEdit', {next: this.saveEdit});
            eventBus.bind('company_invalidate', {next: this.invalidate});
            eventBus.bind('company_revalidate', {next: this.revalidate});
            eventBus.bind('company_remove', {next: this.remove});
        },
        mounted() {

        },
        destroyed() {
            eventBus.unbind('company_saveAdd');
            eventBus.unbind('company_saveEdit');
            eventBus.unbind('company_invalidate');
            eventBus.unbind('company_revalidate');
            eventBus.unbind('company_remove');
        },
    }
</script>

<style scoped>

</style>